const chargeCardInfo = [
    {
        id: 1,
        title: 'Cobranças Pagas',
        quantity: '',
        color: 'green'
    },
    {
        id: 2,
        title: 'Cobranças Vencidas',
        quantity: '',
        color: 'red'
    }, {
        id: 3,
        title: 'Cobranças Previstas',
        quantity: '',
        color: 'yellow'
    },
]

const chargeCardTable = [
    {
        id: 1,
        client: 'Sara Silva',
        chargeId: 223456787,
        value: 'R$ 1000,00'
    },
    {
        id: 2,
        client: 'Carlos Prado',
        chargeId: 223456781,
        value: 'R$ 400,00'
    },
    {
        id: 3,
        client: 'Lara Brito',
        chargeId: 223456782,
        value: 'R$ 900,00'
    },
    {
        id: 4,
        client: 'Soraia Neves',
        chargeId: 223456783,
        value: 'R$ 700,00'
    },
];

export {
    chargeCardInfo,
    chargeCardTable
}